/**
 * @generated SignedSource<<7c7edc88c3a92e3b433dedf65e3db2b4>>
 * @relayHash 82edd5bab8c0bf68a1d51c4ff73be3eb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID eff17170e51b7f3f62f2dfc3cd38656c3039f62e42c8e30f9ab2bd99fe2e6baa

import type { ConcreteRequest } from 'relay-runtime';
export type GraphQLContentStatus = "ARCHIVED" | "CURRENT" | "DELETED" | "DRAFT" | "%future added value";
export type ApprovalActivityHistoryQuery$variables = {
  after?: string | null;
  cloudId: string;
  contentId: string;
  contentStatuses: ReadonlyArray<GraphQLContentStatus | null>;
  first?: number | null;
};
export type ApprovalActivityHistoryQuery$data = {
  readonly confluence_workflowApplicationHistory: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
      readonly node: {
        readonly action: string;
        readonly actor: {
          readonly accountId: string | null;
          readonly displayName: string | null;
        } | null;
        readonly contentId: string;
        readonly contentStatus: GraphQLContentStatus;
        readonly contentVersion: number | null;
        readonly creationDate: {
          readonly value: string;
        };
        readonly id: string;
        readonly reviewDecision: {
          readonly comment: string | null;
          readonly decisionStatus: string | null;
        } | null;
        readonly targetPrincipal: {
          readonly principalId: string | null;
          readonly principalType: string | null;
        } | null;
        readonly triggerSource: string | null;
        readonly workflowApplicationId: string;
        readonly workflowReviewId: string | null;
        readonly workflowStatus: {
          readonly allowsReviews: boolean | null;
          readonly displayProperties: {
            readonly color: string | null;
            readonly description: string | null;
            readonly icon: string | null;
            readonly name: string | null;
          } | null;
          readonly id: string | null;
        } | null;
      } | null;
    } | null> | null;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
    };
  } | null;
};
export type ApprovalActivityHistoryQuery = {
  response: ApprovalActivityHistoryQuery$data;
  variables: ApprovalActivityHistoryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentStatuses"
},
v4 = {
  "defaultValue": 20,
  "kind": "LocalArgument",
  "name": "first"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
      },
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "contentStatuses",
        "variableName": "contentStatuses"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      }
    ],
    "concreteType": "ConfluenceWorkflowApplicationHistoryConnection",
    "kind": "LinkedField",
    "name": "confluence_workflowApplicationHistory",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluenceWorkflowApplicationHistoryEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "cursor"
          },
          {
            "concreteType": "ConfluenceWorkflowApplicationHistoryEntry",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "ScalarField",
                "name": "workflowApplicationId"
              },
              {
                "kind": "ScalarField",
                "name": "workflowReviewId"
              },
              {
                "kind": "ScalarField",
                "name": "contentId"
              },
              {
                "kind": "ScalarField",
                "name": "contentVersion"
              },
              {
                "kind": "ScalarField",
                "name": "contentStatus"
              },
              {
                "kind": "ScalarField",
                "name": "action"
              },
              {
                "kind": "ScalarField",
                "name": "triggerSource"
              },
              {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "creationDate",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "value"
                  }
                ]
              },
              {
                "concreteType": "ConfluenceWorkflowApplicationHistoryActor",
                "kind": "LinkedField",
                "name": "actor",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "accountId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "displayName"
                  }
                ]
              },
              {
                "concreteType": "ConfluenceWorkflowApplicationHistoryTargetPrincipal",
                "kind": "LinkedField",
                "name": "targetPrincipal",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "principalType"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "principalId"
                  }
                ]
              },
              {
                "concreteType": "ConfluenceWorkflowApplicationHistoryReviewDecision",
                "kind": "LinkedField",
                "name": "reviewDecision",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "decisionStatus"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "comment"
                  }
                ]
              },
              {
                "concreteType": "ConfluenceApprovalsWorkflowStatus",
                "kind": "LinkedField",
                "name": "workflowStatus",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "allowsReviews"
                  },
                  {
                    "concreteType": "ConfluenceApprovalsWorkflowStatusDisplayProperties",
                    "kind": "LinkedField",
                    "name": "displayProperties",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "description"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "color"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "icon"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "concreteType": "ConfluencePageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "endCursor"
          },
          {
            "kind": "ScalarField",
            "name": "hasNextPage"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ApprovalActivityHistoryQuery",
    "selections": (v6/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "ApprovalActivityHistoryQuery",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "82edd5bab8c0bf68a1d51c4ff73be3eb",
    "id": "eff17170e51b7f3f62f2dfc3cd38656c3039f62e42c8e30f9ab2bd99fe2e6baa",
    "metadata": {},
    "name": "ApprovalActivityHistoryQuery",
    "operationKind": "query",
    "text": "query ApprovalActivityHistoryQuery($cloudId:ID!,$contentId:ID!,$first:Int=20,$after:String,$contentStatuses:[GraphQLContentStatus]!){confluence_workflowApplicationHistory(cloudId:$cloudId,contentId:$contentId,first:$first,after:$after,contentStatuses:$contentStatuses){edges{cursor,node{id,workflowApplicationId,workflowReviewId,contentId,contentVersion,contentStatus,action,triggerSource,creationDate{value},actor{accountId,displayName},targetPrincipal{principalType,principalId},reviewDecision{decisionStatus,comment},workflowStatus{id,allowsReviews,displayProperties{name,description,color,icon}}}},pageInfo{endCursor,hasNextPage}}}"
  }
};
})();

(node as any).hash = "6cc0197d8f4cc9a98f560e1afe0b1fca";

export default node;
